var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{staticClass:"vuetify-image",attrs:{"height":_vm.height,"width":_vm.width,"contain":_vm.contain,"aspect-ratio":_vm.aspectRatio,"src":_vm.source},on:{"click":function($event){_vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }